import { render } from "./UgTransHomePage.vue?vue&type=template&id=5e3f74d3&scoped=true"
import script from "./UgTransHomePage.vue?vue&type=script&lang=js"
export * from "./UgTransHomePage.vue?vue&type=script&lang=js"

import "./UgTransHomePage.vue?vue&type=style&index=0&id=5e3f74d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3f74d3"]])

export default __exports__